import * as React from 'react';
import { connect } from 'react-redux';
import { Grid, Spinner, Typography } from '@upperhand/playmaker';
import { getToken } from 'utils/auth';

import './Login.css';
import LoginForm from './LoginForm';
import CustomerSelector from './CustomerSelector';

const Login = ({ isLoading, roles }) => {
  const loginState =
    !!getToken() && roles.length ? (
      <CustomerSelector roles={roles} />
    ) : (
      <LoginForm />
    );

  return (
    <div className="Login fullHeight">
      <Grid container spacing={4} alignItems="center" justify="center">
        <Grid item>
          <img
            src="https://upperhand-app.s3.amazonaws.com/static/images/Upper+Hand+Dark+Logo.svg"
            alt="Upper Hand logo"
          />
        </Grid>
        <Grid item>
          <Typography component="h1" variant="h1" align="center">
            Log in to Upper Hand Kiosk
          </Typography>
        </Grid>
        {isLoading ? <Spinner /> : loginState}
      </Grid>
    </div>
  );
};

const mapStateToProps = ({ auth: { isLoading, roles } }) => ({
  isLoading,
  roles,
});

export default connect(mapStateToProps)(Login);
